import { ForecastChartCaption, OverviewForecastYearOnYearChart, SettingValue } from 'src/app/models/forecast/fc-overview-models';
import { ReturnFlag } from '../return-flag';
/************************Deep Dive Page Data classes************************* */

/*class Common*/
/* Overview Forecast Main Chart  */
export class DeepDiveForecastDevelopmentChart {
  yearMonth: string;
  period: string;
  month: number;
  tenderCampaign: number;
  forecastFinal: number;
  forecastPerito: number;
  actual: number;
  actualLY: number;
  actualLY2: number;
  actualLY3: number;
  lastReleased: number;
  actualClean: number;
}

/* Overview Forecast Main Chart  */
export class DeepDiveForecastDevelopmentNewChart {
  period: string;
  final1: number;
  final2: number;
  final3: number;
  released: number;
  actual: number;
  actualClean: number;
  forecastKeyFigure1: number;
  forecastKeyFigure2: number;
  forecastKeyFigure3: number;
  forecastKeyFigure4: number;
  forecastKeyFigure5: number;
  forecastKeyFigure6: number;
  forecastKeyFigure7: number;
  forecastKeyFigure8: number;
  forecastKeyFigure9: number;
  forecastKeyFigure10: number;
  addOn1: number;
  addOn2: number;
  addOn3: number;
  addOn4: number;
  addOn5: number;
  actual1: number;
  actual2: number;
  actual3: number;
}

/*  Overview Forecast Seasonality Chart */
export class DeepDiveForecastSeasonalityChart {
  season: string;
  act1Pct: number;
  act2Pct: number;
  act3Pct: number;
  fcPct: number;
  minValue: number;
  maxValue: number;
}

/* Overview Forecast Year On Year Chart */
export class DeepDiveForecastYearOnYearChart {
  act2: number;
  act1: number;
  fC1: number;
  fC2: number;
  act3: number;
}

export class DataFDeepDiveDto {
  forecastDevelopmentChart: DeepDiveForecastDevelopmentChart[];
  forecastYearOnYearChart: OverviewForecastYearOnYearChart[];
  forecastSeasonalityChart: DeepDiveForecastSeasonalityChart[];
  forecastMasterTableData: MasterTableData[];
  forecastCurrentValidationData: CurrentValidation;

  forecastElementNames: ElementNames[];
  forecastElementData: ElementData[];
  forecastFieldObejctData: FieldDynamicObject;
  flags: ReturnFlag;
}

export class DataFDeepDiveNewDto {
  forecastDevelopmentChart: DeepDiveForecastDevelopmentNewChart[];
  forecastYearOnYearChart: OverviewForecastYearOnYearChart[];
  forecastSeasonalityChart: DeepDiveForecastSeasonalityChart[];
  forecastMasterTableData: MasterTableData[];
  forecastCurrentValidationData: CurrentValidation;

  forecastElementNames: ElementNewNames[];
  forecastElementData: ForecastElementNewData[];
  forecastFieldObejctData: FieldDynamicObject;
  flags: ReturnFlag;
  forecastChartCaption: ForecastChartCaption[];
  settingValue: SettingValue[];
  deepdiveNewFieldCaption: ForecastChartCaption[];

}

/* Deep-dive Master Table Data */
export class ElementNewNames {
  forecastElementId: number;
  forecastElementName: string;
  forecastElementType: string;
  basicForecastPriority: number;
  enableUserInput: boolean;
  forecastElementFieldName: string;
  includeInFinalForecast1: boolean;
  includeInFinalForecast2: boolean;
  includeInFinalForecast3: boolean;
}

/* Deep-dive Master Table Data */
export class MasterTableData {
  name: string;
  value: string;
  caption: string;
}

/* Deep-dive  Data */
export class DeepDiveMasterTableData {
  masterData: MasterTableData[];
  secondHeaderName: string;
}


/* Deep-dive Current Validation */
export class CurrentValidation {
  issue: string;
  peritoComment: string;
  clientResponse: string;
  clientcomment: string;
  permanentComment: string;
}

/* Deep-dive Master Table Data */
export class ElementNames {
  forecastElementId: number;
  forecastElementName: string;
	forecastElementFieldName: string;
  forecastElementType: string;
  basicForecastPriority: number;
  enableUserInput: boolean;
}

/* Deep-dive Master Table Data */
export class ElementData {
  forecastElementId: number;
  periods: string;
  // forecast: number;
  finalForecast1: number;
  finalForecast2: number;
  finalForecast3: number;
  basicForecastPriority: number;
  forecastElementType: string;
  forecastPerito: number;
  entryUser: string;
  elemntComment: string;
}

/* Deep-dive Master Table Data */
export class FieldDynamicObject {
  headerName: string;
  roundOff: number;
  displayMinRoundingBelowNumberFc: number;
  displayMinRoundingPlacesFc: number; 
  forecastObjectId: string;
  periodName: string;
  secondHeaderName: string;
  realignmentForecastObjectId: string;
  currentValidationId: string;
  multipleFactor: number;
  forecastObjectProductImageHeight: any;
  forecastObjectProductImagePath: any;
  forecastObjectProductImageWidth: any;
}

/* Deep-dive Master Table Data */
export class DeepDiveListTable {
  fields: ForecastDeepDiveColumnData[];
  values: any[];
  total: number;
}

export class ForecastDeepDiveColumnData {
  caption: string;
  fieldName: string;
}

/* Deep-dive Master Table Data */
export class DeepDiveUpdateComment {
  PermanentComment: string;
  ForecastObjectClientId: string;
  ClientResponse: string;
  ClientComment: string;
  ClientOtherComment: string;
}


/* Deep-dive Update Elemnt Data */
export class UpdateForecastElemtData {
  forecastElementData: ForecastElementData[];
  forecastCommentData: ForecastCommentData[];

  ForecastObjectId: string;
  ModifyBy: string;
  UpdateFromPeriod: number;
  UpdateToPeriod: number;
}

export class ForecastElementData {
  CommercialObjectId: number = -1;
  ForecastElementId: number;
  Period: string;
  Forecast: number;
  EntryBy: string;
}

export class ForecastElementUpdateNewData {
  ForecastObjectId: string;
  action: string;
  multipleFactor: number; 
  forecastData: ForecastElementNewData[];
  comment: DeepDiveUpdateCommentNew;
  KeyFigureData: KeyFigureData[];
  KeyFigureFields: KeyValuePair[];
}

export class KeyValuePair {
  KeyPair: string;
  ValuePair: string;
}


export class KeyFigureData {
  KeyFigure1: number;
  KeyFigure2: number;
  KeyFigure3: number;
  KeyFigure4: number;
  KeyFigure5: number;
  KeyFigure6: number;
  KeyFigure7: number;
  KeyFigure8: number;
  KeyFigure9: number;
  KeyFigure10: number;
  period: number;
  ForecastObjectId: string;
  commercialObjectId: number;
}

export class DeepDiveUpdateCommentNew {
  ClientComment: string;
  ClientResponse: string;
  ClientOtherComment: string;
  ForecastObjectClientId: string;
  PermanentComment: string;
}


export class ForecastElementNewData {
  period: string;
  entryUser: string;
  ElemntComment: string;
  basic1: number;
  basic2: number;
  basic3: number;
  addOn1: number;
  addOn2: number;
  addOn3: number;
  addOn4: number;
  addOn5: number;
  commercialObjectId: number;
}

export class ForecastCommentData {
  Period: string;
  ElemntComment: string;
}

export class ForecastElementUpdateMultiData { 
  action: string;
  forecastData: ForecastElementMultiData[]; 
  KeyFigureData: KeyFigureData[];
  KeyFigureFields: KeyValuePair[];
}

export class ForecastElementMultiData {
  period: string;
  entryUser: string;
  ElemntComment: string;
  basic1: number;
  basic2: number;
  basic3: number;
  addOn1: number;
  addOn2: number;
  addOn3: number;
  addOn4: number;
  addOn5: number;
  ForecastObjectId: string; 
  commercialObjectId: number;
}
